import logoAgents from "../../image/Logo_agents.svg";
import logoAuto from "../../image/Logo_auto.svg";
import logoCore from "../../image/Logo_core.svg";
import logoDrug from "../../image/Logo_drug.svg";
import logoEducation from "../../image/Logo_education.svg";
import logoFinance from "../../image/Logo_finance.svg";
import logoGenom from "../../image/Logo_genom.svg";
import logoRobotics from "../../image/Logo_robotics.svg";
import logoSecurity from "../../image/Logo_security.svg";

/** Static map for businessUnits.json `Image` filenames — avoids dynamic require + layout shift. */
export const BUSINESS_UNIT_NAV_LOGOS: Record<string, string> = {
    "Logo_agents.svg": logoAgents,
    "Logo_auto.svg": logoAuto,
    "Logo_core.svg": logoCore,
    "Logo_drug.svg": logoDrug,
    "Logo_education.svg": logoEducation,
    "Logo_finance.svg": logoFinance,
    "Logo_genom.svg": logoGenom,
    "Logo_robotics.svg": logoRobotics,
    "Logo_security.svg": logoSecurity,
};

export function getBusinessUnitNavLogoSrc(filename: string): string | undefined {
    return BUSINESS_UNIT_NAV_LOGOS[filename];
}
